module.exports = __webpack_public_path__ + "img/touXiang6.a2ea5bee.png";